import React from 'react';
import styles from '../../styles/OurBoxes.module.css';

export function AgeGroupImageButton(props: {
  readonly title: string;
  readonly image: string;
  readonly onClick: () => void;
  readonly small?: boolean;
}) {
  return (
    <div
      className={`${props.small ? styles.ageGroupOptionSmall : ''} ${styles.ageGroupOption}`}
      style={{
        backgroundImage: `url("${props.image}")`,
      }}
      onClick={props.onClick}
    >
      <p className={`display-6 ${styles.ageGroupOptionTitle}`}>{props.title}</p>
    </div>
  );
}
